import { LoyaltyMembershipConfigurationDto, PagesLoyaltyProgramCheckInGetDto } from "clearline-api";

export interface BalanceInfo {
  id: string;
  fullName: string;
  phoneNumber: string;
  email: string;
  uniqueCode: string;
  balanceValue: number;
  balanceCurrency: string;
  cards: RewardCardView[];
  membershipCard: MembershipCardView | null;
}

export interface RewardCard {
  imageUrl: string;
  title: string;
  subTitle: string;
  session: string;
  campaign: string;
  claimed: boolean;
}

export type RewardCardView = RewardCard & { pending?: boolean };

export type MembershipCardView = LoyaltyMembershipConfigurationDto & { description: string };

export interface CheckInBalanceData {
  balance: PagesLoyaltyProgramCheckInGetDto;
  cashRegisterId: number;
}

export type CheckInResult = {
  status: "success" | "error";
  data: PagesLoyaltyProgramCheckInGetDto | null;
};
